import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=a9fc06a4&scoped=true&"
import script from "./EventManagement.vue?vue&type=script&lang=js&"
export * from "./EventManagement.vue?vue&type=script&lang=js&"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=a9fc06a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc06a4",
  null
  
)

export default component.exports